export const SYSCONFIG_LOAD_REQUEST = "SYSCONFIG/LOAD_REQUEST";
export const SYSCONFIG_LOAD_SUCCESS = "SYSCONFIG/LOAD_SUCCESS";
export const SYSCONFIG_LOAD_FAIL = "SYSCONFIG/LOAD_FAIL";

export const SYSCONFIG_DOCUMENT_BUILDER_CHAINS_UPDATE_REQUEST = "SYSCONFIG_DOCUMENT_BUILDER_CHAINS/UPDATE_REQUEST";
export const SYSCONFIG_DOCUMENT_BUILDER_CHAINS_UPDATE_SUCCESS = "SYSCONFIG_DOCUMENT_BUILDER_CHAINS/UPDATE_SUCCESS";
export const SYSCONFIG_DOCUMENT_BUILDER_CHAINS_UPDATE_FAIL = "SYSCONFIG_DOCUMENT_BUILDER_CHAINS/UPDATE_FAIL";

export const SYSCONFIG_ENV_CHAINS_UPDATE_REQUEST = "SYSCONFIG_ENV_CHAINS/UPDATE_REQUEST";
export const SYSCONFIG_ENV_CHAINS_UPDATE_SUCCESS = "SYSCONFIG_ENV_CHAINS/UPDATE_SUCCESS";
export const SYSCONFIG_ENV_CHAINS_UPDATE_FAIL = "SYSCONFIG_ENV_CHAINS/UPDATE_FAIL";

export const defaultScopeId = "v3.AI.chainInstance.systemPrompt";

export default (
  state = {
    loading: 0,
    syschains: { documentBuilder: []},
    envchains: [],
    errors: [],
  },
  { type, data }
) => {
  switch (type) {
  case SYSCONFIG_LOAD_REQUEST: {
    ++state.loading;
    return state;
  }
  case SYSCONFIG_LOAD_SUCCESS: {
    --state.loading;
    state.syschains = data?.syschains;
    state.envchains = data?.envchains;
    return state;
  }
  case SYSCONFIG_LOAD_FAIL: {
    --state.loading;
    // state.errors.push({ error: data, type });
    return state;
  }
  case SYSCONFIG_DOCUMENT_BUILDER_CHAINS_UPDATE_REQUEST: {
    ++state.loading;
    return state;
  }
  case SYSCONFIG_DOCUMENT_BUILDER_CHAINS_UPDATE_SUCCESS: {
    --state.loading;
    return state;
  }
  case SYSCONFIG_DOCUMENT_BUILDER_CHAINS_UPDATE_FAIL: {
    --state.loading;
    state.errors.push({ error: data, type });
    return state;
  }
  default:
    return state;
  }
};

export const loadRequested = data => ({ type: SYSCONFIG_LOAD_REQUEST, data });
export const loadSuccess = data => ({ type: SYSCONFIG_LOAD_SUCCESS, data });
export const loadFail = data => ({ type: SYSCONFIG_LOAD_FAIL, data });

export const updateDocumentBuilderChainRequested = data => ({ type: SYSCONFIG_DOCUMENT_BUILDER_CHAINS_UPDATE_REQUEST, data });
export const updateDocumentBuilderChainSuccess = data => ({ type: SYSCONFIG_DOCUMENT_BUILDER_CHAINS_UPDATE_SUCCESS, data });
export const updateDocumentBuilderChainFail = data => ({ type: SYSCONFIG_DOCUMENT_BUILDER_CHAINS_UPDATE_FAIL, data });

export const updateEnvChainRequested = data => ({ type: SYSCONFIG_ENV_CHAINS_UPDATE_REQUEST, data });
export const updateEnvChainSuccess = data => ({ type: SYSCONFIG_ENV_CHAINS_UPDATE_SUCCESS, data });
export const updateEnvChainFail = data => ({ type: SYSCONFIG_ENV_CHAINS_UPDATE_FAIL, data });
